'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  header: '',
  link: 'Clear all',
  footer: ''
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/instantsearch.js/dist-es5-module/src/widgets/clear-all/defaultTemplates.js
// module id = 1115
// module chunks = 20 21 22 23 24 25 26 27 28